import { api } from '@/lib/api';
import type {
  ApiCoinPost,
  ApiCoinComment,
  CoinFeedParams,
  CreateCoinPostDto,
} from '@/lib/types';

export async function getCoinPostsFeed(params?: CoinFeedParams): Promise<ApiCoinPost[]> {
  const qs = params ? '?' + new URLSearchParams(
    Object.entries(params)
      .filter(([, v]) => v !== undefined && v !== null)
      .map(([k, v]) => [k, String(v)])
  ).toString() : '';
  const result = await api<ApiCoinPost[] | { items?: ApiCoinPost[]; data?: ApiCoinPost[] }>(`/coin-posts/feed${qs}`);
  if (Array.isArray(result)) return result;
  if (result && 'items' in result && result.items) return result.items;
  if (result && 'data' in result && result.data) return result.data;
  return [];
}


export async function getCoinPostsTotal(params?: CoinFeedParams): Promise<number> {
  const qs = params
    ? '?' +
    new URLSearchParams(
      Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([k, v]) => [k, String(v)])
    ).toString()
    : '';

  const result = await api<{ totalItems?: number }>(`/coin-posts/feed${qs}`);

  return result.totalItems ?? 0;
}

export async function getCoinPostById(id: string): Promise<ApiCoinPost> {
  return api<ApiCoinPost>(`/coin-posts/${id}`);
}

export async function createCoinPost(dto: CreateCoinPostDto): Promise<ApiCoinPost> {
  return api<ApiCoinPost>('/coin-posts', {
    method: 'POST',
    body: JSON.stringify(dto),
  });
}

export async function deleteCoinPost(id: string): Promise<void> {
  return api<void>(`/coin-posts/${id}`, { method: 'DELETE' });
}

export async function addCoinReaction(id: string): Promise<void> {
  return api<void>(`/coin-posts/${id}/reactions`, { method: 'POST' });
}

export async function removeCoinReaction(id: string): Promise<void> {
  return api<void>(`/coin-posts/${id}/reactions`, { method: 'DELETE' });
}

export async function getCoinComments(id: string): Promise<ApiCoinComment[]> {
  const result = await api<ApiCoinComment[] | { items?: ApiCoinComment[]; data?: ApiCoinComment[] }>(`/coin-posts/${id}/comments`);
  if (Array.isArray(result)) return result;
  if (result && 'items' in result && result.items) return result.items;
  if (result && 'data' in result && result.data) return result.data;
  return [];
}

export async function addCoinComment(id: string, content: string): Promise<ApiCoinComment> {
  return api<ApiCoinComment>(`/coin-posts/${id}/comments`, {
    method: 'POST',
    body: JSON.stringify({ content }),
  });
}


// Supprime un commentaire d'une publication Le Coin.
// Le backend autorise l'auteur du commentaire ainsi que les Admin/Moderator.
export async function deleteCoinPostComment(
  postId: string,
  commentId: string,
): Promise<void> {
  return api<void>(`/coin-posts/${postId}/comments/${commentId}`, {
    method: 'DELETE',
  });
}

export async function reportCoinPost(id: string, reason: string): Promise<void> {
  return api<void>(`/coin-posts/${id}/reports`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}

export async function getMyCoinPosts(): Promise<ApiCoinPost[]> {
  const result = await api<ApiCoinPost[] | { items?: ApiCoinPost[]; data?: ApiCoinPost[] }>('/users/me/coin-posts');
  if (Array.isArray(result)) return result;
  if (result && 'items' in result && result.items) return result.items;
  if (result && 'data' in result && result.data) return result.data;
  return [];
}

